<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2024-01-18 11:49:45
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="showCont" >
      <!-- 第一层 -->
      <div class="province">
        <span class="iconfont icon-arrow-r-copy" style="color: #e6c69c;"></span>
        <span class="text province_desc">
          省级:
          <span>{{ bmyjs.chnldesc }}</span>
        </span>
        <div :class="{ 'active': activeItem === bmyjs.chnldesc}" class="curLevel" @click="getdata(' ',bmyjs)">
          {{ bmyjs.chnldesc }}本级
        </div>
      </div>
      <!-- 第二层 -->
      <div class="city" v-if="city && city.length>0">
        <div class="city_desc">
          <span class="iconfont icon-arrow-r-copy" style="color: #e6c69c;"></span>
          <span class="text">市级:</span>
        </div>
        <div class="city_list">
            <div class="city_text" v-for="(itemc,indexc) in city" :key="indexc">
              <div @mouseenter="getareaData(itemc)">
                {{ itemc.chnldesc }}
                <div v-if="itemc.show" class="iconfont icon-jiantoushang"></div>
              </div>
            </div>
        </div>
        <div :class="{ 'active': activeItem === curCity.chnldesc}" class="curLevel" @click="getdata(bmyjs,curCity)">
          {{ curCity.chnldesc }}本级
        </div>
      </div>
      <!-- 边框 -->
      <div class="three_box">
        <!-- 第三层 -->
        <div class="area" v-if="area && area.length>0">
          <div class="text area_desc">县(市、区):</div>
          <div class="area_list">
              <div class="area_text" v-for="(itema,indexa) in area" :key="indexa">
                <div @mouseenter="getTownData(itema)">
                  {{ itema.chnldesc }}
                  <div v-if="itema.show" class="iconfont icon-jiantoushang"></div>
                </div>
              </div>
          </div>
          <div v-if="showArea" :class="{ 'active': activeItem === curAara.chnldesc}" class="curLevel curlevela" @click="getdata(curCity,curAara)">
            {{ curAara.chnldesc }}本级
          </div>
        </div>
        <!-- 第四层 -->
        <div class="town" v-if="showTown && town && town.length>0">
          <span class="text town_desc">乡镇:</span>
          <div class="town_list">
              <div class="town_text" v-for="(itemt,indext) in town" :key="indext">
                <div :class="{ 'active': activeItem === itemt.chnldesc}" @click="getdata(curAara,itemt)">
                  {{ itemt.chnldesc }}
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeDialog2',
  props: {
    year: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bmyjs: {},
      city: [],
      curCity: {},
      area: [],
      curAara: {},
      town: [],
      curTown: {},
      showTown: false,
      activeItem: '',
      showArea: false,
      scaleh: 1
    }
  },
  computed: {
    getWindowSized () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  watch: {
    scaleh: {
      handler (val) {
        window.addEventListener('load', this.handleResizeh)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResizeh()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResizeh)
    window.addEventListener('resize', this.handleResizeh)
  },
  methods: {
    handleResizeh () {
      var width = this.getWindowSized.width
      // 假设你设计稿的宽度是 1920PX
      var designWidth = 1920
      var scale = width / designWidth
      this.scaleh = scale.toFixed(2)
    },
    getareaData (data) {
      this.showArea = false
      this.showTown = false
      this.curCity = data
      this.city.forEach(item => {
        item.show = false
        if (item.chnldesc === data.chnldesc) {
          item.show = true
        }
      })
      this.$forceUpdate(this.city)
      this.area = data.child
    },
    getTownData (data) {
      this.curAara = data
      this.showArea = true
      this.area.forEach(item => {
        item.show = false
        if (item.chnldesc === data.chnldesc) {
          item.show = true
        }
      })
      this.$forceUpdate(this.area)
      this.town = data.child
      if (this.town.length > 0) {
        this.showTown = true
      }
    },
    getdata (data1, data2) {
      if (data1) {
        if (data2.qhtype === 1) {
          this.$emit('curtext', data2)
          this.activeItem = data2.chnldesc
        } else {
          this.$emit('curtext', data1)
          this.activeItem = data2.chnldesc
        }
      } else {
        this.$emit('curtext', data2)
        this.activeItem = data2.chnldesc
      }
    },
    async getchannelData () {
      await this.$http.get('/api/wcmchannel/findxzqh', {
        params: {
          year: this.year,
          openType: 'ys'
        }
      }).then(res => {
        this.bmyjs = res.data.data
        if (this.bmyjs.haschild) {
          this.city = this.bmyjs.child
          this.city.forEach(item => {
            item.show = false
            if (item.chnldesc === '南京市') {
              this.area = item.child
              this.curCity = item
            }
            if (item.haschild) {
              item.child.forEach(val => {
                val.show = false
              })
            }
          })
        }
      })
    }
  },
  async created () {
    await this.getchannelData()
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}
ul li {
  list-style: none;
}
.showCont{
  width: 960PX;
  height: 560PX;
  position: relative;
  margin: 0 auto;
  padding: 20PX;
  font-size: 18PX;
  font-weight: 400;
  color: #fff;
}
.text {
  font-size: 18PX;
  font-weight: 400;
  color: #fff !important;
  opacity: 1 !important;
  cursor: pointer;
}
.active{
  color: #e6c69c !important;
}
.curLevel{
  color: rgba(250, 251, 252, 0.8);
  cursor: pointer;
  font-size: 18PX;
  margin-left: 24PX;
  margin-top: 15PX;
}
.province_desc span{
  margin-left: 5PX;
}
.city{
  position: relative;
  margin-top: 15PX;
  cursor: pointer;
}
.city_desc{
  position: absolute;
}
.city_list{
  margin-left: 52PX;
}
.area{
  position: relative;
  cursor: pointer;
}
.area_desc{
  position: absolute;
}
.area_list{
  margin-left: 85PX;
}
.area_text{
  height: 40PX;
  margin-left: 15PX;
}
.town{
  position: relative;
  margin-top: 10PX;
  cursor: pointer;
}
.town_desc{
  position: absolute;
  top: 6PX;
}
.town_list{
  margin-left: 38PX;
  height: 160PX;
  overflow: auto;
}
.town_text{
  margin-left: 15PX;
  line-height: 38PX;
}
.curlevela{
  margin-left: 0PX !important;
}
.city_text,.area_text,.town_text{
  display: inline-block;
}
.city_text{
  height: 40PX;
  margin-left: 20PX;
  position: relative;
}
.three_box{
  width: 928PX;
  height: 285PX;
  overflow: auto;
  border: 1PX solid #1c6493;
  padding: 20PX 40PX;
  margin-top: 10PX;
  background: rgba(62, 107, 153, 0.79);
}
.icon-jiantoushang{
  position: absolute;
  margin-left: 20PX;
  margin-top: 5PX;
}
/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 5PX;
}

::-webkit-scrollbar-track {
  background-color: rgba(60, 104, 151, 0.9);
}

::-webkit-scrollbar-thumb {
  background-color: #b2b0b0;
  border-radius: 5PX;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

</style>



// WEBPACK FOOTER //
// src/components/homeDialog2.vue